"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
RegisterService.$inject = ['api'];
function RegisterService(api) {
    var service = {};
    return service;
}
exports.RegisterService = RegisterService;



//////////////////
// WEBPACK FOOTER
// ./scripts/core/register/services/register.js
// module id = 327
// module chunks = 0